<template>
  <div class="flex flex-col items-center w-full pb-2">
    <img :src="image" alt="" class="max-h-[170px]" />
    <p class="text-neutral-500">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "MobEmptyState",
  props: {
    image: String,
    text: String,
  },
};
</script>
